import { Helmet } from "react-helmet-async";

function Gone(_props) {
  return (
    <>
      <section
        className="bg-dark-image full-height"
        style={{ background: "no-repeat center / cover", backgroundImage }}
      >
        <div className="container">
          <div className="text-center">
            <h1 className="hero-bold">OOOPS</h1>
          </div>
          <div className="text-center">
            <h2 className="hero-small">
              The page you are looking for does not exist.
            </h2>
          </div>
          <div className="text-center">
            <a className="btn btn-primary" href="/">
              Go to mainpage
              <i className="las la-angle-right is-200" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </section>
      <Helmet meta={[{ name: "prerender-status-code", content: "500" }]} />
    </>
  );
}
const backgroundImage = [
  "linear-gradient(rgba(46, 53, 60, 0.7), rgba(46, 53, 60, 0.7))",
  "url(https://unsplash.com/photos/Bs0zgYkYEZw/download)",
].join(", ");

export default Gone;
